import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { useTopPartnerId } from 'legacy/lut/hooks/useTopPartnerId'
import { useEffect, useState } from 'react'

import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { PAGE_CONFIG } from '../../../../configs'
import { getDecoratedFetchFn } from '../../../../helpers/getDecoratedFetchFn'
import { IContactTab } from '../../../../models'

interface IUseAllContactsSource extends Partial<IContactTab> {}

export function useAllContactsSource({
  partnerId = '',
  onAfterFetch,
  onBeforeFetch,
  onCatchError,
}: IUseAllContactsSource) {
  const [source, setSource] = useState<Crud>()
  const { topPartnerId } = useTopPartnerId(partnerId)

  useEffect(() => {
    const crud = CrudStore.get(
      CrudStoreItem.ContactAllData,
      `partnerContacts-contactList-${partnerId}`
    )
    // const originalFetchFn = crud.fetch.bind(crud)
    const isHeadquarter = partnerId === topPartnerId
    const filterByPartnerId = {
      field: 'PartnerID',
      operator: Operator.EQUAL,
      value: partnerId,
    }
    //
    // crud.fetch = getDecoratedFetchFn({
    //   context: crud,
    //   originalFetchFn,
    //   onAfterFetch,
    //   onBeforeFetch,
    //   onCatchError,
    // })

    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'TopPartnerID',
          operator: Operator.EQUAL,
          value: topPartnerId,
        },
      ],
    })

    crud.setFilter({ logic: Logic.AND, filters: isHeadquarter ? [] : [filterByPartnerId] })

    crud.setSort([
      {
        dir: 'desc',
        field: 'IsKeyContact',
      },
      {
        field: 'LastName',
        dir: 'asc',
      },
    ])

    crud.setPaging(PAGE_CONFIG)

    setSource(crud)
  }, [onAfterFetch, onBeforeFetch, onCatchError, partnerId, topPartnerId])

  return { source }
}
